import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useMeContext } from '../../app/MeContext';
import { useScreen } from '../../app/shell-context';
import { formatDayWithWeekday, formatTime } from '../../lib/time';
import { reminderCopy } from '../../lib/reminders';
import { BellIcon, CalendarIcon, MessageIcon, SealIcon } from '../../ui/icons';
import { useBooking } from '../BookingContext';

/** Экран «готово» — общий для новой записи и переноса. */
export function Done() {
  const me = useMeContext();
  const navigate = useNavigate();
  const { booking, reset } = useBooking();
  const tz = me.center.tz;
  const tf = me.center.timeFormat;

  useScreen('Готово', {
    label: 'На главную',
    onClick: () => {
      reset();
      navigate('/', { replace: true });
    },
  });

  const moved = booking.flow === 'move';

  return (
    <Screen className="success">
      <div className="seal"><SealIcon /></div>
      <h2>{moved ? 'Запись перенесена' : 'Вы записаны'}</h2>
      <p>
        {booking.startsAt
          ? `${formatDayWithWeekday(booking.startsAt, tz)} · ${formatTime(booking.startsAt, tz, tf)}`
          : 'Детали придут в чат'}
      </p>
      <div className="card" style={{ width: '100%', textAlign: 'left', marginTop: 6 }}>
        <ul className="meta">
          <li>
            <span className="ico"><CalendarIcon /></span>
            <span>Запись видна на главной — там же можно перенести или отменить</span>
          </li>
          {reminderCopy(me.center.reminders, 'Бот напомнит') ? (
            <li>
              <span className="ico"><BellIcon /></span>
              <span>{reminderCopy(me.center.reminders, 'Бот напомнит')}</span>
            </li>
          ) : null}
          <li>
            <span className="ico"><MessageIcon /></span>
            <span>
              Уведомление о записи ушло специалисту{booking.specialistName ? ` — ${booking.specialistName}` : ''}
            </span>
          </li>
        </ul>
      </div>
    </Screen>
  );
}
